@if (isViewVisible()) {
  <div class="bp-modal mod-lg" [class.elevated]="(isFirstStep && !!tradableId) || isSecondStep">
    @if (!summary && !created) {
      @if (currentStep; as header) {
        <bp-modal-header
          class="font-semibold"
          [title]="header.title"
          [showIndicator]="!isVerificationMandatory()">
          @if (header.left; as left) {
            <a
              left
              (click)="onHeaderButtonClick(left)"
              (keydown.enter)="onHeaderButtonClick(left)"
              [tabIndex]="0">
              {{ left | translate }}
            </a>
          }
          @if (header.right; as right) {
            <a
              right
              (click)="onHeaderButtonClick(right)"
              (keydown.enter)="onHeaderButtonClick(right)"
              [tabIndex]="0">
              {{ right | translate }}
            </a>
          }
        </bp-modal-header>
      }
      @if (!isVerificationMandatory()) {
        <div class="bp-modal-body">
          <div
            class="bp-modal-body-section"
					[ngClass]="{
						'pb-0': isThirdStep,
						'mod-no-padding': isTradableListSelection()
					}">
            <!--
            *
            *   SELECT WALLET TITLES
            *
            -->
            @if (!isTradableListSelection() && isFirstStep) {
              <div class="bp-modal-description">
                {{ "choose_the_wallet_you_want_to_deposit_money_to" | translate }}
              </div>
            }
            <div
						[ngClass]="{
							'bp-modal-description': isSecondStep,
							'text-center pb-20 text-summary-description': isThirdStep
						}">
              @if (isSecondStep) {
                {{ "select_a_payment_method" | translate }}
              }
              @if (isThirdStep) {
                {{ "how_much_money_do_you_want_to_deposit" | translate }}
              }
            </div>
            <!--
            *
            *   SELECT FIAT or CRYPTO WALLETS for DEPOSIT
            *
            -->
            @if (isFirstStep) {
              <tradable-list-item
                [fiatWallets]="wallets"
                [(tradableId)]="tradableId"
                [tradables]="getDepositTradables()"
                [action]="'deposit'"
                (onFiatSelect)="selectWallet($event)"
                (onSelect)="navigateToWallet($event)"
                (onRefresh)="doTrapFocusTime()"
                [selectedCryptocoin]="selectedCryptocoin">
              </tradable-list-item>
            }
            <!--
            *
            *   SELECT ACCOUNT
            *
            -->
            @if (isSecondStep) {
              @if (isDepositDiscountActive()) {
                <div class="best-fee-collection__deposit_reduction">
                  <div class="best-fee-collection__best_background">
                    <span class="best-fee-collection__best_icon bpi__asset-best"></span>
                  </div>
                  <div class="best-fee-collection__info_text">
                    {{
                    "best_fee_collection_deposit_reduction_description"
                    | translate: [currentBestRewardLevel]
                    }}
                    @for (provider of getEligibleProviderForFiat$() | async; track provider) {
                      {{
                      getBestFeeString(provider)
                      }}
                      }!
                    </div>
                  </div>
                }
                <div class="modal-grid mod-two-cols">
                  @for (p of getAvailableProviders$() | async; track p) {
                    <provider-tile
                      [ngClass]="'grid-item'"
                      [provider]="p"
                      [fiat]="fiat"
                      [fiats]="fiats"
                      [active]="isSame(p, provider)"
                      [tabIndex]="0"
                      (click)="selectProvider(p)"
                      (keydown.enter)="selectProvider(p)">
                    </provider-tile>
                  }
                </div>
                <div class="modal-grid mod-two-cols">
                  @for (p of getUnavailableProviders$() | async; track p) {
                    <provider-tile
                      [ngClass]="'grid-item'"
                      [provider]="p"
                      [fiats]="fiats"
                      [disabled]="true"
                      bp-tooltip="{{ providerTooltip }}"
                      position="top">
                    </provider-tile>
                  }
                </div>
                @if (depositSurveyLink) {
                  <div class="deposit-footer">
                    <a
                      class="text-green"
                      target="_blank"
                      [href]="depositSurveyLink"
                      (click)="onClickDepositSurveyLink()"
                      (mousedown)="onMousedownDepositSurveyLink($event)">
                      {{ "help_us_improve_this_experience" | translate }}
                    </a>
                  </div>
                }
              }
              <!--
              *
              *   AMOUNTS
              *
              -->
              @if (isThirdStep) {
                <div class="modal-grid mod-three-cols">
                  @for (amount of amounts; track amount) {
                    <fiat-amount-tile
                      class="grid-item"
                      [fiat]="fiat"
                      [amount]="amount"
                      (click)="setAmount(amount)">
                    </fiat-amount-tile>
                  }
                  @if (maxAmount > 0) {
                    <fiat-amount-tile
                      class="grid-item"
                      [fiat]="fiat"
                      [amount]="maxAmount"
                      [max]="'max_amount_deposit' | translate"
                      (click)="setAmount(maxAmount)">
                    </fiat-amount-tile>
                  }
                </div>
              }
            </div>
            @if (isThirdStep) {
              <div class="bp-modal-body-section mod-fullwidth pt-30">
                <div class="items-start flex-wrap modal-internal-transfer mod-input">
                  <bp-input
                    class="mod-input-line"
                    iconLeading="true"
                    type="fiat"
                    [iconUrl]="fiat?.getLogo()"
                    [iconUrlAltText]="'logo_alt_text' | translate"
                    min="0"
                    name="amount_fiat"
                    [step]="getStepsFromOfferFiat()"
                    required
                    autofocus
                    [(value)]="data.transaction.amount"
                    [formGroupClass]="false"
                    (valueChange)="userWants()"
                    bpInputNumberLeadingTrailingDot>
                    <a
                      right
                      class="hover-pointer color-primary form-field-group-addon fiat-fees-toggle"
                      (click)="switchType()"
                      href="javascript:"
                      [tabIndex]="0">
                      {{ getFeeTypeLabel(false) | translate }}
                    </a>
                  </bp-input>
                </div>
                <!-- labels: min amount + fees info -->
                <div class="bp-modal-row mt-10 bp-modal-custom-margin modal-internal-transfer mod-input">
                  @if (minTransactionAmount() > 0) {
                    <div class="bp-modal-column left">
                      {{ "min_amount_deposit_AMOUNT" | translate: ["" + minTransactionAmount()] }}
                      {{ fiat?.getSymbol() }}
                    </div>
                  }
                </div>
                <hr class="mb-20 mt-30" />
                <div class="pl-50 pr-50">
                  <div class="bp-modal-row font-size-24" [ngClass]="{ 'text-light': !isSufficient() }">
                    <div class="bp-modal-column left mr-5">{{ "amount_total" | translate }}</div>
                    <div class="bp-modal-column right break">
                      <strong>
                        {{ amount | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] } }}
                      </strong>
                    </div>
                  </div>
                  <div class="bp-modal-row font-size-15">
                    <div class="bp-modal-column left text-opaque">
                      @if (showFee()) {
                        {{ getFeeTypeLabel() | translate }}
                        @if (showFeeAdditionalInfo()) {
                          <span>
                            {{
                            getProviderFee()?.getFeeFix()
                            | fiat_precision_symbol
                            : { id: fiat?.getId(), symbol: true, currencies: [fiat] }
                            }}
                            +
                          </span>
                        }
                        {{
                        getProviderFee()?.getFeePercent()
                        | fiat_precision: { id: fiat?.getId(), currencies: [fiat] }
                        }}% {{ "fees" | translate }}
                        @if (showFeeAdditionalInfo(false)) {
                          <span
                            >({{ "fee_max" | translate
                            }}{{
                            getProviderFee()?.getFeeMax()
                            | fiat_precision_symbol
                            : { id: fiat?.getId(), symbol: true, currencies: [fiat] }
                            }})
                          </span>
                        }
                      }
                    </div>
                    <div class="bp-modal-column right break"></div>
                  </div>
                </div>
                <div class="pl-30 pr-30 mt-20 text-center">
                  <button
                    class="btn btn-primary btn-lg btn-summary mod-amount"
                    type="button"
                    (click)="setSummary()"
                    [ngClass]="!isSufficient() ? 'disabled' : ''">
                    {{ "goto_summary" | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="bp-modal-body">
            <div class="bp-modal-body-section">
              @if (!isVerificationPending()) {
                <div class="modal-add-info mb-30">
                  <h3 class="modal-add-info-headline">
                    {{ "because_of_verification_you_cant_use_deposit_header" | translate }}
                  </h3>
                  <p class="modal-add-info-text text-narrowest center-block">
                    {{ "modal_unverified_deposit" | translate }}
                  </p>
                  <button
                    class="modal-add-info-button btn btn-primary btn-inverse btn-bold btn-bigger-text"
                    (click)="verify()"
                    type="button">
                    <i class="bpi__icon-verify"></i>
                    {{ "start_verification_here_button" | translate }}
                  </button>
                </div>
              } @else {
                <div class="modal-add-info mb-30 pt-20">
                  <h3 class="modal-add-info-headline">
                    {{ "modal_verification_progress_title" | translate }}
                  </h3>
                  <p class="modal-add-info-text text-narrow center-block">
                    {{ "modal_verification_progress_info" | translate }}
                  </p>
                </div>
              }
            </div>
          </div>
        }
      }
      @if (summary) {
        <fiat-deposit-summary
          (errorCloseEmitter)="closeErrorFlow()"
          [offer]="data.transaction"
          (finish)="setCreated($event)"
          (edit)="setEdit($event)"
          (onClose)="close()">
        </fiat-deposit-summary>
      }
      <span class="bp-modal-body-2fa-deposit">
        @if (needsVerification) {
          <two-fa-verify
            [offer]="data"
            (pinSentF)="pinSent = $event"
            (accept)="pinConfirmed($event)"
            >
          </two-fa-verify>
        }
      </span>
    </div>
  }
